import * as React from "react";
import {
  Toaster,
  useToastController,
  Toast,
  ToastTitle,
  ToastBody,
} from "@fluentui/react-components";

const ToastContext = React.createContext(
  undefined
);

export const ToastProvider = ({ children }) => {
  const toasterId = React.useId();
  const { dispatchToast } = useToastController(toasterId);

  const showToast = (title, body, options) => {
    dispatchToast(
      <Toast>
        <ToastTitle>{title}</ToastTitle>
        {body && <ToastBody>{body}</ToastBody>}
      </Toast>,
      {
        intent: "info",
        timeout: 5000, // auto-dismiss after 5s
        ...options,
      }
    );
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toaster toasterId={toasterId} />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = React.useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
